import { render } from "./CircleHelpIcon.vue?vue&type=template&id=a1e10cc0"
const script = {}

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__